"use client";

import { c as _c } from "react/compiler-runtime";
import { type ShortInternalLinkProps, type ShortProps, Short as SharedShort } from "@defuse/ui/short";
import { KNOWN_CHAINS, NEAR_INTENTS_EXPLORER_URL } from "@intents-explorer/shared-api/chains";
import { LinkWithLoader } from "@/components/route-loader";
export function Short(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SharedShort {...props} renderInternalLink={renderInternalLink} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function renderInternalLink({
  href,
  className,
  onClick,
  scroll,
  children
}: ShortInternalLinkProps) {
  return <LinkWithLoader href={href} className={className} onClick={onClick} {...scroll !== undefined && {
    scroll
  }}>
			{children}
		</LinkWithLoader>;
}
export function getTxLink(chain: string | undefined, txHash: string | undefined) {
  return chain === undefined || chain === "" || KNOWN_CHAINS[chain]?.txExplorerUrl === undefined || txHash === undefined || txHash === "" ? undefined : `${KNOWN_CHAINS[chain].txExplorerUrl}${txHash}`;
}
export function getAddressLink(chain: string | undefined, address: string | undefined) {
  return chain === undefined || chain === "" || KNOWN_CHAINS[chain]?.addressExplorerUrl === undefined || address === undefined || address === "" ? undefined : `${KNOWN_CHAINS[chain].addressExplorerUrl}${address}`;
}
export function getIntentLink(intentHash: string | undefined) {
  return intentHash === undefined || intentHash === "" ? undefined : `${NEAR_INTENTS_EXPLORER_URL}${intentHash}`;
}